/**
 * Loggerのログレベル定義
 */
const logLevel = {
  debug: 0,
  info: 10,
  warn: 20,
  error: 30
}

/**
 * 出力対象ログレベル
 */
const minLogLevel = logLevel.debug

/**
 * デバッグ用コンソールの使用有無
 */
const enableConsole = true

const defaultDBName = 'rahmen'
const loggerStoreName = 'logger'
const cacheStoreName = 'cache'
const loginInfoStoreName = 'ddv2_loginInfo'
const logPostUrl = '/api/v1/logger/store'

// add by yam for login screen
const beforeLoginInfoStoreName = 'ddv2_beforeLoginInfo'
const tempDataStoreName = 'ddv2_tempData'

const storeVersion = 4 // need countup to change db structures

const storeNameList = [
  loggerStoreName,
  cacheStoreName,
  loginInfoStoreName,
  beforeLoginInfoStoreName,
  tempDataStoreName
]

// HttpClientにて、401権限エラー時のメッセージ
const unauthorizedMessage = 'データへのアクセス権限がありません。\nログイン画面に遷移しますので再度ログインしてください。'
// HttpClientにて、403権限エラー時のメッセージ
const unauthorizedMessage2 = 'データへのアクセス権限がありません'

export default {
  logLevel,
  minLogLevel,
  enableConsole,
  defaultDBName,
  loggerStoreName,
  cacheStoreName,
  loginInfoStoreName,
  logPostUrl,
  storeNameList,
  storeVersion,
  beforeLoginInfoStoreName,
  unauthorizedMessage,
  unauthorizedMessage2,
  tempDataStoreName
}
